import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRole from "../../authorization/hooks/useHasRole";

import SuperAdminView from "../views/SuperAdminView/SuperAdminView";

export default function SuperAdmin(props) {
	const hasRole = useHasRole();

	if (!hasRole("owner", "admin")) {
		return <Unauthorized />;
	}

	return <SuperAdminView {...props} />;
}
